import type { AppConfig } from '../config';
import { isDemo } from '../config';
import type { ApiStore } from './api';
import type { DemoStore } from './demo';

export type AppStore = DemoStore | ApiStore;

/** The right store for this configuration. The backend store (and with it MSAL) is only downloaded when it's needed. */
export async function createStore(config: AppConfig, demo = false): Promise<AppStore> {
  if (isDemo(config) || demo) {
    const { DemoStore } = await import('./demo');
    return new DemoStore(config.demoSeedUrl);
  }
  const [{ ApiStore }, { createMsalAuth }] = await Promise.all([import('./api'), import('../auth/msal')]);
  return new ApiStore(config, createMsalAuth(config));
}
